// Blocked Users List Component
// Following existing patterns from ConversationList

import React from 'react';
import { BlockedUser } from '../../types/safety';
import {
  BlockedUsersList as StyledBlockedUsersList,
  BlockedUserItem,
  BlockedUserAvatar,
  BlockedUserInfo,
  BlockedUserName,
  BlockedUserDetails,
  BlockedUserActions,
  UnblockButton,
  EmptyBlockedUsersState,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateDescription
} from '../../styles/Safety';

interface BlockedUsersListProps {
  blockedUsers: BlockedUser[];
  onUnblock: (userId: string) => Promise<void>;
  isLoading?: boolean;
}

export const BlockedUsersList: React.FC<BlockedUsersListProps> = ({
  blockedUsers,
  onUnblock,
  isLoading = false
}) => {
  const getInitials = (name: string) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  const formatDate = (date: Date) => {
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    
    if (days === 0) return 'Today';
    if (days === 1) return 'Yesterday';
    if (days < 7) return `${days} days ago`;
    if (days < 30) return `${Math.floor(days / 7)} weeks ago`;
    return `${Math.floor(days / 30)} months ago`;
  };

  if (isLoading) {
    return (
      <EmptyBlockedUsersState>
        <EmptyStateIcon>⏳</EmptyStateIcon>
        <EmptyStateTitle>Loading...</EmptyStateTitle>
      </EmptyBlockedUsersState>
    );
  }

  if (blockedUsers.length === 0) {
    return (
      <EmptyBlockedUsersState>
        <EmptyStateIcon>🔒</EmptyStateIcon>
        <EmptyStateTitle>No Blocked Users</EmptyStateTitle>
        <EmptyStateDescription>
          You haven't blocked any users yet. Blocked users won't be able to contact you or see your profile.
        </EmptyStateDescription>
      </EmptyBlockedUsersState>
    );
  }

  return (
    <StyledBlockedUsersList>
      {blockedUsers.map((blockedUser) => (
        <BlockedUserItem key={blockedUser.id}>
          <BlockedUserAvatar $photo={blockedUser.user?.photo}>
            {!blockedUser.user?.photo && blockedUser.user?.name && (
              getInitials(blockedUser.user.name)
            )}
          </BlockedUserAvatar>
          <BlockedUserInfo>
            <BlockedUserName>
              {blockedUser.user?.name || 'Unknown User'}
            </BlockedUserName>
            <BlockedUserDetails>
              <div>Blocked {formatDate(blockedUser.blockedAt)}</div>
              {blockedUser.reason && (
                <div>Reason: {blockedUser.reason}</div>
              )}
            </BlockedUserDetails>
          </BlockedUserInfo>
          <BlockedUserActions>
            <UnblockButton
              onClick={() => onUnblock(blockedUser.blockedUserId)}
            >
              Unblock
            </UnblockButton>
          </BlockedUserActions>
        </BlockedUserItem>
      ))}
    </StyledBlockedUsersList>
  );
};






